import React, { useState, useMemo } from 'react';
import { apagarCheque } from '~/Services/Service';
import { Button, Card, Table, Form, Row, Col } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import { toast } from 'react-toastify';
import { incluirCheque } from '~/Services/Service';
import moment from 'moment';
import { FaTrashAlt, FaAngleUp, FaAngleDown } from 'react-icons/fa';

const TelaChequeBonus = ({ empreendimentoId, chequesData = [], onRefresh }) => {
  const [prospecto, setProspecto] = useState(0);
  const [valor, setValor] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ordenacao, setOrdenacao] = useState({ coluna: null, direcao: 'asc' });
  const [colunaHover, setColunaHover] = useState(null);

  const handleOrdenacao = coluna => {
    setOrdenacao(prev => ({
      coluna,
      direcao:
        prev.coluna === coluna && prev.direcao === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getIconeOrdenacao = coluna => {
    if (ordenacao.coluna !== coluna) return '';
    return ordenacao.direcao === 'asc' ? <FaAngleUp /> : <FaAngleDown />;
  };

  const dadosOrdenados = useMemo(() => {
    if (!chequesData || !ordenacao.coluna) return chequesData || [];

    return [...chequesData].sort((a, b) => {
      const valorA = a[ordenacao.coluna];
      const valorB = b[ordenacao.coluna];

      if (valorA == null && valorB == null) return 0;
      if (valorA == null) return ordenacao.direcao === 'asc' ? 1 : -1;
      if (valorB == null) return ordenacao.direcao === 'asc' ? -1 : 1;

      if (typeof valorA === 'string') {
        const comparacao = valorA.localeCompare(valorB, 'pt-BR');
        return ordenacao.direcao === 'asc' ? comparacao : -comparacao;
      }

      if (ordenacao.direcao === 'asc') {
        return valorA - valorB;
      }
      return valorB - valorA;
    });
  }, [chequesData, ordenacao]);

const tableStyles = {
  wrapper: {
    borderRadius: '8px',
    border: '1px solid #dee2e6',
    maxHeight: '300px',
    overflowY: 'auto',
    overflowX: 'auto',
  },
  header: {
    backgroundColor: '#0747a6',
    color: '#fff',
    borderColor: '#0747a6',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.2s',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  headerHover: {
    backgroundColor: '#053580',
  },
};

  const colunasCheques = [
    { chave: 'codigo', label: 'Código' },
    { chave: 'nome', label: 'Nome do Cliente' },
    { chave: 'documentacao_completa', label: 'Pasta' },
    { chave: 'valor', label: 'Valor' },
    { chave: 'data', label: 'Data' },
    { chave: 'codigo_proposta', label: 'Proposta' },
  ];

  const handleSubmitIncluir = async () => {
    if (!prospecto || prospecto <= 0) {
      toast.warning('Informe um prospecto válido!');
      return;
    }

    if (!valor || valor <= 0) {
      toast.warning('Informe um valor válido!');
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = {
        familia: empreendimentoId,
        valor: valor,
        prospecto: prospecto
      };
      await incluirCheque(payload);
      toast.success('Cheque incluido com sucesso!');
      setProspecto(0);
      setValor(0);
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      console.error('Erro incluir cheque:', error);
      toast.error('Erro ao incluir cheque.');
    } finally {
      setIsSubmitting(false);
    }
  };

    const handleApagarCheque = async (codigo) => {
      try {
        await apagarCheque(codigo);
        toast.success('Cheque apagado com sucesso!');
        if (onRefresh) {
          onRefresh();
        }
      } catch (error) {
        console.error('Erro ao apagar:', error);
        toast.error('Erro ao apagar cheque.');
      }
    };

  return (
    <div className="bg-white my-3">
      <Header title="Prospecto - Cheque Bônus" />

      <Row className="px-3 my-3">
        {/* Coluna Esquerda - Definir Cheque */}
        <Col xs={12} lg={6} className="mb-3 mb-lg-0">
          <Card className="h-auto">
            <Card.Header className="bg-light">
              <h5 className="mb-0">Definir Cheque Bônus</h5>
            </Card.Header>
            <Card.Body>
              {/* Em mobile: empilha verticalmente, em desktop: lado a lado */}
              <Row className="align-items-end">
                <Col xs={6} sm={4} lg={4} className="mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-1">Prospecto</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      size="sm"
                      value={prospecto}
                      onChange={e => setProspecto(e.target.value)}
                      disabled={isSubmitting}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} sm={4} lg={4} className="mb-3">
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-1">Valor R$</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      size="sm"
                      value={valor}
                      onChange={e => setValor(e.target.value)}
                      disabled={isSubmitting}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4} lg={4} className="mb-3">
                  <Button
                    variant="outline-success"
                    onClick={handleSubmitIncluir}
                    className="w-100"
                    size="sm"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Incluindo...' : 'Incluir Cheque'}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* Coluna Direita - Cheques Encontrados */}
        <Col xs={12} lg={6}>
          <Card className="h-100">
            <Card.Header className="bg-light">
              <h5 className="mb-0">Cheque Bônus Encontrados</h5>
            </Card.Header>
            <Card.Body className="p-0 p-sm-3">
              <style>
                {`
                  .tabela-cheques {
                    width: 100%;
                    font-size: 0.75rem;
                  }
                  .tabela-cheques tbody tr:hover {
                    background-color: #e8f4ff !important;
                  }
                  .tabela-cheques thead th {
                    position: sticky;
                    top: 0;
                    z-index: 2;
                    background-color: #0747a6;
                    white-space: nowrap;
                    padding: 0.35rem 0.4rem;
                    font-size: 0.7rem;
                  }
                  .tabela-cheques td {
                    padding: 0.3rem 0.4rem;
                    white-space: nowrap;
                  }
                  .tabela-cheques th:last-child,
                  .tabela-cheques td:last-child {
                    text-align: center;
                    width: 50px;
                  }

                  @media (max-width: 768px) {
                    .tabela-cheques {
                      font-size: 0.85rem;
                    }
                    .tabela-cheques thead {
                      display: none;
                    }
                    .tabela-cheques tbody tr {
                      display: block;
                      margin-bottom: 1rem;
                      border: 1px solid #dee2e6;
                      border-radius: 8px;
                      overflow: hidden;
                    }
                    .tabela-cheques tbody td {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      padding: 0.75rem 1rem;
                      border: none;
                      border-bottom: 1px solid #eee;
                      white-space: normal;
                    }
                    .tabela-cheques tbody td:last-child {
                      border-bottom: none;
                      width: auto;
                    }
                    .tabela-cheques tbody td::before {
                      content: attr(data-label);
                      font-weight: 600;
                      color: #0747a6;
                      margin-right: 1rem;
                    }
                  }
                `}
              </style>
              <div style={tableStyles.wrapper}>
                <Table bordered hover size="sm" className="mb-0 tabela-cheques">
                  <thead>
                    <tr>
                      {colunasCheques.map(col => (
                        <th
                          key={col.chave}
                          style={{
                            ...tableStyles.header,
                            ...(colunaHover === col.chave
                              ? tableStyles.headerHover
                              : {}),
                          }}
                          onClick={() => handleOrdenacao(col.chave)}
                          onMouseEnter={() => setColunaHover(col.chave)}
                          onMouseLeave={() => setColunaHover(null)}
                        >
                          {col.label}
                          <span
                            style={{ fontSize: '0.75rem', marginLeft: '4px' }}
                          >
                            {getIconeOrdenacao(col.chave)}
                          </span>
                        </th>
                      ))}
                      <th style={tableStyles.header} className="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosOrdenados.length > 0 ? (
                      dadosOrdenados.map((c, idx) => (
                        <tr key={c.codigo || idx}>
                          <td data-label="Código">{c.codigo}</td>
                          <td data-label="Nome do Cliente">{c.nome}</td>
                          <td data-label="Pasta">{c.documentacao_completa}</td>
                          <td data-label="Valor">R${c.valor ? c.valor.toFixed(2) : '0.00'}</td>
                          <td data-label="Data">{c.data ? moment(c.data).format('DD/MM/YYYY HH:mm') : ''}</td>
                          <td data-label="Proposta">{c.codigo_proposta}</td>
                          <td data-label="Ações" className="text-center">
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleApagarCheque(c.codigo)}
                            >
                              <FaTrashAlt />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-3">
                          Nenhum cheque bônus encontrado
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TelaChequeBonus;